import * as sharedStyles from './style.module.css';
const colours = {
    base: sharedStyles.colourBase,
    subtle: sharedStyles.colourSubtle,
    subdued: sharedStyles.colourSubdued,
    inverted: sharedStyles.colourInverted,
    negative: sharedStyles.colourNegative,
    warning: sharedStyles.colourWarning,
    positive: sharedStyles.colourPositive,
    disabled: sharedStyles.colourDisabled,
    'urgency-medium': sharedStyles.colourUrgencyMedium,
    'urgency-high': sharedStyles.colourUrgencyHigh,
};
export default colours;
//# sourceMappingURL=colours.js.map